import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";
import firebase from "../../fire";
import PageTitle from "../../components/common/PageTitle";
import { Link } from "react-router-dom";
import Skeleton from "@material-ui/lab/Skeleton";

const AdsListing = () => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    getVideoAds();
    // getVideoAds().then(function (result) {
    //   result.forEach((data) => {
    //     console.log("--result", data);

    //     setLoading(false);
    //     setAds((previous) => [...previous, data]);
    //   });
    // });
  }, []);

  async function getVideoAds() {
    const db = firebase.firestore();
    const snapshot = await db.collection("ads").get();
    snapshot.docs.map((doc) => {
      const dt = doc.data();
      console.log("getVideo Ads", doc.data(), doc.id);
      setLoading(false);
      setAds((previous) => [...previous, { ...dt, _id: doc.id }]);
    });
  }

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="" subtitle="ADs " className="text-sm-left" />
      </Row>

      {/* Default Light Table */}
      <Row>
        <Col>
          <Card small className="mb-4">
            <CardHeader className="border-bottom">
              <h6 className="m-0">All TV ADs</h6>
              <Link
                className={"btn btn-primary btn-sm float-left"}
                to="/create-ads"
              >
                Create
              </Link>
            </CardHeader>

            <CardBody className="p-0 pb-3">
              <table className="table mb-0">
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0">
                      #
                    </th>
                    <th scope="col" className="border-0">
                      Name
                    </th>
                    <th scope="col" className="border-0">
                      No of Time Ad Play
                    </th>
                    <th scope="col" className="border-0">
                      Ad Link
                    </th>

                    <th scope="col" className="border-0">
                      Videos Link
                    </th>
                    <th scope="col" className="border-0">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? ads &&
                      ads.map((i, index) => (
                        <tr key={index}>
                          <td>
                            <Skeleton className="py-3" />
                          </td>
                          <td>
                            <Skeleton className="py-3" />
                          </td>
                          <td>
                            <Skeleton className="py-3" />
                          </td>
                          <td>
                            <Skeleton className="py-3" />
                          </td>
                        </tr>
                      ))
                    : ads &&
                      ads.map((i, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="text-capitalize">{i.name}</td>

                          <td>{i.times}</td>
                          <td>
                            <a target="_blank" href={i.file_name}>
                              Link
                            </a>
                          </td>
                          <td>
                            {i.video?.map((data, id) => (
                              <a
                                className="mr-2"
                                target="_blank"
                                href={data.file_name}
                              >
                                Video {id + 1}
                              </a>
                            ))}
                          </td>
                          <td>
                            <Link
                              className={"btn btn-primary btn-sm float-left"}
                              to={{ pathname: "/edit-ads", data: { video: i } }}
                            >
                              Edit
                            </Link>
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdsListing;
